export default function VideoDescription({ text = "" }) {
  const content = [];
  const urls = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;
  let offset = 0;
  for (const match of text.matchAll(urls)) {
    let label = match[0].replace(/[.,!?;:]+$/, "");
    // Leave sentence punctuation outside the link, retaining balanced URL brackets.
    while (/[)\]}]$/.test(label)) {
      const close = label.slice(-1), open = { ")": "(", "]": "[", "}": "{" }[close];
      if (label.split(close).length <= label.split(open).length) break;
      label = label.slice(0, -1).replace(/[.,!?;:]+$/, "");
    }
    const href = /^www\./i.test(label) ? `https://${label}` : label;
    try {
      const url = new URL(href);
      if (!["http:", "https:"].includes(url.protocol) || !url.hostname) continue;
    } catch { continue; }
    content.push(text.slice(offset, match.index));
    content.push(<a key={match.index} href={href} target="_blank" rel="noopener noreferrer">{label}</a>);
    offset = match.index + label.length;
  }
  content.push(text.slice(offset));
  return <p className="videoDetailDescription">{content}</p>;
}
